/* eslint-disable @typescript-eslint/no-explicit-any */
import {useEffect, useState} from 'react';
import { defaultValues, showErrorValuesDefault, showErrorValuesSubmit } from '../../data/constants/demanderAvenant';
import { IError } from '../../data/types/interface/demanderAvenant';

export const useForm = (
  data: any,
  Validate: any,
  handleCancel: any,
  handleSave: any,
  listAgence?: any,
  listContrat?: any,
) => {
  const [values, setValues] = useState(data);
  const [dto, setDto] = useState({error: true, data});
  const [showErrors, setShowErrors] = useState(showErrorValuesDefault);
  const [errors, setErrors] = useState<IError>(defaultValues);

  const handleChange = (
    name: string,
    value: any,
    fired: boolean,
  ) => {
    const _value = value;

    setValues({...values, [name]: _value});
    setShowErrors({...showErrors, [name]: _value !== fired});
  };

  const noError = () => {
    let bNoError = true;
    Object.values(errors).forEach((element) => {
      if (element !== '') {
        bNoError = false;
      }
    });
    return bNoError;
  };

  const handleSubmit = () => {
    setShowErrors(showErrorValuesSubmit);
    setErrors(Validate(values, listAgence, listContrat));
    console.log('submit avenant', Validate(values, listAgence, listContrat));
    if (noError()) {
      setDto({error: false, data: values});
    } else {
      setDto({error: true, data: {}});
    }
  };

  useEffect(() => {
    setErrors(Validate(values, listAgence, listContrat));
  }, [values]);

  useEffect(() => {
    if (!dto.error) {
      handleSave();
    }
  }, [dto]);

  return {handleChange, handleSubmit, values, errors, showErrors, dto};
};
